import type shellEn from "./shell.en";

const shellFr: Record<keyof typeof shellEn, string> = {
  "admin.shell.AdminSidebar.0": "Dashboard",
  "admin.shell.AdminSidebar.1": "Liens courts",
  "admin.shell.AdminSidebar.2": "Contenu",
  "admin.shell.AdminSidebar.3": "Articles",
  "admin.shell.AdminSidebar.4": "Ressources",
  "admin.shell.AdminSidebar.5": "Suggestions",
  "admin.shell.AdminSidebar.6": "Membres & trafic",
  "admin.shell.AdminSidebar.7": "Membres",
  "admin.shell.AdminSidebar.8": "Logs inscriptions",
  "admin.shell.AdminSidebar.9": "Sécurité",
  "admin.shell.AdminSidebar.10": "Sécurité",
  "admin.shell.AdminSidebar.11": "Audit",
  "admin.shell.AdminSidebar.12": "Tentatives de connexion",
  "admin.shell.AdminSidebar.13": "Défis forcés",
  "admin.shell.AdminSidebar.14": "Analyse & accès IP",
  "admin.shell.AdminSidebar.15": "Réglages",
  "admin.shell.AdminSidebar.16": "Paramètres",
  "admin.shell.AdminSidebar.17": "Nouvelle inscription reçue",
  "admin.shell.AdminSidebar.19": "Voir le site",
  "admin.shell.AdminSidebar.20": "Déconnexion",
  "admin.shell.AdminSidebar.21": "Déconnexion",
  "admin.shell.AdminRoute.1": "Vérification des permissions...",
  "admin.shell.AdminRoute.2": "Accès refusé",
  "admin.shell.AdminRoute.3": "Vous n'avez pas les permissions nécessaires pour accéder à cette page.",
  "admin.shell.AdminKPIs.1": "En attente",
  "admin.shell.AdminKPIs.3": "Inscriptions à traiter",
  "admin.shell.AdminKPIs.4": "Total inscrits",
  "admin.shell.AdminKPIs.6": "Toutes inscriptions",
  "admin.shell.AdminKPIs.7": "Membres actifs",
  "admin.shell.AdminKPIs.9": "Connexion < 30 jours",
  "admin.shell.AdminKPIs.10": "Visites aujourd'hui",
  "admin.shell.AdminKPIs.12": "Depuis minuit",
  "admin.shell.BulkActionsBar.0": "Accorder l'accès membre",
  "admin.shell.BulkActionsBar.1": "Envoyer invitation WhatsApp",
  "admin.shell.BulkActionsBar.2": "Envoyer lien magique",
  "admin.shell.BulkActionsBar.3": "Changer le statut",
  "admin.shell.BulkActionsBar.4": "Supprimer",
  "admin.shell.BulkActionsBar.5": "sélectionné",
  "admin.shell.BulkActionsBar.6": "Aucune inscription éligible (toutes ont déjà un profil membre)",
  "admin.shell.BulkActionsBar.7": "Accorder accès",
  "admin.shell.BulkActionsBar.8": "Aucune inscription éligible",
  "admin.shell.BulkActionsBar.9": "WhatsApp",
  "admin.shell.BulkActionsBar.10": "Aucune inscription éligible (accès non validé)",
  "admin.shell.BulkActionsBar.11": "Lien magique",
  "admin.shell.BulkActionsBar.12": "Statut",
  "admin.shell.BulkActionsBar.14": "Supprimer",
  "admin.shell.BulkActionsBar.15": "Effacer",
  "admin.shell.BulkActionsBar.16": "Action en masse sur",
  "admin.shell.BulkActionsBar.17": "inscription",
  "admin.shell.BulkActionsBar.18": "sélectionnée",
  "admin.shell.BulkActionsBar.20": "éligible",
  "admin.shell.BulkActionsBar.22": "ignorée",
  "admin.shell.BulkActionsBar.24": "En attente",
  "admin.shell.BulkActionsBar.25": "Contacté",
  "admin.shell.BulkActionsBar.26": "Ajouté au groupe",
  "admin.shell.BulkActionsBar.27": "Retiré du groupe",
  "admin.shell.BulkActionsBar.28": "Cette action est irréversible.",
  "admin.shell.BulkActionsBar.29": "L'envoi sera espacé (~200ms entre chaque) pour respecter les limites de débit.",
  "admin.shell.BulkActionsBar.30": "Annuler",
  "admin.shell.BulkActionsBar.32": "En cours...",
  "admin.shell.Admin.1": "Erreur lors de la suppression",
  "admin.shell.Admin.2": "Article supprimé avec succès",
  "admin.shell.Admin.3": "Croissance des inscriptions",
  "admin.shell.Admin.4": "3 mois",
  "admin.shell.Admin.5": "6 mois",
  "admin.shell.Admin.6": "12 mois",
  "admin.shell.Admin.9": "Évolution cumulative",
  "admin.shell.Admin.10": "depuis le début",
  "admin.shell.Admin.11": "3 mois",
  "admin.shell.Admin.12": "6 mois",
  "admin.shell.Admin.13": "12 mois",
  "admin.shell.Admin.15": "Cumulé",
  "admin.shell.Admin.16": "Pas assez de données pour afficher le graphique",
  "admin.shell.Admin.17": "Articles de blog",
  "admin.shell.Admin.18": "Publiés",
  "admin.shell.Admin.19": "Planifiés",
  "admin.shell.Admin.22": "Nouvel article",
  "admin.shell.Admin.23": "Chargement...",
  "admin.shell.Admin.24": "Aucun article pour le moment",
  "admin.shell.Admin.25": "Créer le premier article",
  "admin.shell.Admin.26": "Aucun article dans cette catégorie.",
  "admin.shell.Admin.29": "📅 Planifié",
  "admin.shell.Admin.30": "✓ Publié",
  "admin.shell.Admin.31": "vue",
  "admin.shell.Admin.33": "Aperçu",
  "admin.shell.Admin.34": "Modifier",
  "admin.shell.Admin.35": "Supprimer",
  "admin.shell.Admin.36": "Confirmer la suppression",
  "admin.shell.Admin.37": "Êtes-vous sûr de vouloir supprimer cet article ? Cette action est irréversible.",
  "admin.shell.Admin.38": "Annuler",
  "admin.shell.Admin.39": "Supprimer",
  "admin.shell.nav.Links": "Liens",
  "admin.shell.nav.Announcements": "Annonces",
  "admin.shell.nav.Visitors": "Visiteurs",
  "admin.shell.nav.Canaries": "Canaris",
  "admin.shell.nav.Dashboard": "Dashboard",
  "admin.shell.nav.All": "Tous",
  "admin.shell.nav.Month": "Mois",
  "admin.shell.publication": "Publication le {date}",
  "admin.shell.eligibleCount": "{count} éligible(s)",
  "admin.shell.dashboard.All": "Tous",
  "admin.shell.dashboard.Max": "Max",
  "admin.shell.over": "sur {range}",
  "admin.shell.registrants": "{count} inscrits"
};

export default shellFr;
